var _rect, _rect2, _path, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloseButton = function SvgCloseButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 28,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 28,
    x: 0.5,
    fill: "#000",
    fillOpacity: 0.5,
    rx: 14
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 27,
    x: 1,
    y: 0.5,
    stroke: "#fff",
    strokeOpacity: 0.15,
    rx: 13.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.679 11.519q-.435 0-.772.17-.332.166-.561.484-.225.317-.342.767a4 4 0 0 0-.117 1.01q0 .757.185 1.294.191.533.586.816.396.278 1.02.278.435 0 .87-.098.44-.098.952-.278v1.27q-.474.194-.933.278-.459.087-1.03.088-1.104 0-1.816-.454a2.74 2.74 0 0 1-1.05-1.28q-.342-.825-.342-1.924 0-.81.22-1.484a3.4 3.4 0 0 1 .644-1.167 2.85 2.85 0 0 1 1.05-.762q.625-.268 1.436-.268.532 0 1.064.136.537.132 1.026.367l-.489 1.23a8 8 0 0 0-.805-.332 2.4 2.4 0 0 0-.796-.141m4.716 5.981h-1.489V9.902h1.49zm6.529-2.74q0 .685-.186 1.212-.18.528-.532.893-.346.361-.84.547a3.1 3.1 0 0 1-1.103.186q-.576 0-1.06-.186a2.36 2.36 0 0 1-.835-.547 2.55 2.55 0 0 1-.547-.893 3.6 3.6 0 0 1-.19-1.211q0-.909.322-1.538.323-.63.918-.957.595-.328 1.421-.328.766 0 1.357.328a2.3 2.3 0 0 1 .933.957q.342.63.342 1.538m-3.775 0a3 3 0 0 0 .118.904q.117.366.366.552.248.185.65.185.395 0 .639-.185.249-.186.361-.552a3 3 0 0 0 .117-.903q0-.542-.117-.899-.112-.36-.361-.542-.25-.18-.65-.18-.59 0-.859.405-.264.405-.264 1.216m8.814 1.119q0 .557-.264.942-.258.381-.776.581-.517.195-1.29.196-.57 0-.98-.074a4 4 0 0 1-.821-.244v-1.23q.445.2.952.332a3.8 3.8 0 0 0 .899.127q.434 0 .62-.127a.4.4 0 0 0 .19-.342.4.4 0 0 0-.078-.244q-.073-.112-.322-.25a8 8 0 0 0-.782-.365 5 5 0 0 1-.844-.435 1.5 1.5 0 0 1-.488-.518q-.157-.302-.157-.766 0-.757.586-1.138.591-.386 1.577-.386.508 0 .967.103.465.102.952.327l-.449 1.074a8 8 0 0 0-.766-.288 2.4 2.4 0 0 0-.728-.112q-.327 0-.493.088a.29.29 0 0 0-.166.268q0 .132.083.235.087.102.332.23.249.121.727.317.464.19.806.4.342.205.527.513.186.303.186.786m3.413-3.94q.758 0 1.304.292.546.29.844.84.298.552.298 1.348v.723h-3.52q.024.63.376.99.356.357.986.357.522 0 .957-.107.435-.108.894-.322v1.152q-.406.2-.85.293-.44.093-1.07.093-.82 0-1.454-.303a2.26 2.26 0 0 1-.992-.923q-.356-.62-.356-1.562 0-.958.322-1.592.327-.64.908-.957.582-.322 1.353-.322m.01 1.059q-.434 0-.723.278-.284.279-.327.874h2.09a1.5 1.5 0 0 0-.122-.59.9.9 0 0 0-.342-.41q-.225-.152-.576-.152"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "close-button_svg__a",
    width: 19,
    height: 18,
    x: 43,
    y: 5,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 14,
    r: 9,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    mask: "url(#close-button_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 14,
    r: 8.25,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m49.5 11 6 6m0-6-6 6"
  }))));
};
export default SvgCloseButton;